import { Component, OnInit } from '@angular/core';
import { AuthState, selectUserInfo } from '@emi/shared/state/auth';
import { select, Store } from '@ngrx/store';
import * as Constants from '@emi/shared/constants';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EmailBuilder } from '@emi/shared/builders';
import { Email } from '@emi/shared/models';
import {
    getHelpResourcesState,
    HelpResourcesState,
    sendContactUsFeedback,
    fetchContactUsAccountManagers,
    resetFeedbackResult,
} from '@emi/shared/state/help-resources';

//TODO: DataVersionService -> Amend to Email
//TODO: Google Analytics

@Component({
    selector: 'via-feedback-form',
    templateUrl: './feedback-form.component.html',
    styleUrls: ['./feedback-form.component.scss'],
})
export class FeedbackFormComponent implements OnInit {
    public userData: any;
    public accountManagerEmail: string;
    public contactUsFormGroup: FormGroup;
    public response?: string;
    public isSuccessful: boolean | undefined;
    public showResponse: boolean | undefined;
    public topics = [
        Constants.FeedbackTopics.ACCOUNT_MANAGER_QUERY,
        Constants.FeedbackTopics.TECHNICAL_SUPPORT,
        Constants.FeedbackTopics.DATA_QUERY,
        Constants.FeedbackTopics.OTHER_QUERY,
    ];

    constructor(
        private store: Store<AuthState>,
        private helpResourcesStore: Store<HelpResourcesState>,
        private emailBuilder: EmailBuilder,
    ) {}

    public ngOnInit(): void {
        this.helpResourcesStore.dispatch(resetFeedbackResult());
        this.store.pipe(select(selectUserInfo)).subscribe((user) => (this.userData = user.userData));
        this.helpResourcesStore.dispatch(fetchContactUsAccountManagers());
        this.helpResourcesStore.select(getHelpResourcesState).subscribe((helpResourcesStore) => {
            if (helpResourcesStore.accountManagers.length > 0) {
                this.accountManagerEmail = helpResourcesStore.accountManagers[0].email;
            }

            this.isSuccessful = helpResourcesStore.isSendFeedbackSuccessful;
            this.showResponse = helpResourcesStore.isSendFeedbackSuccessful;
            this.response = helpResourcesStore.isSendFeedbackSuccessful
                ? Constants.SupportMessages.FEEDBACK_SUCCESS
                : Constants.SupportMessages.FEEDBACK_ERROR;
        });

        this.contactUsFormGroup = new FormGroup({
            topic: new FormControl(Constants.FeedbackTopics.ACCOUNT_MANAGER_QUERY, Validators.required),
            message: new FormControl(null, Validators.required),
        });
    }

    public get emailBasedOnTopic(): string {
        if (this.accountManagerEmail && this.accountManagerEmail.includes('Passport.Support')) {
            this.accountManagerEmail = Constants.SupportEmails.TECHNICAL_SUPPORT_EMAIL;
        }

        const emails: any = {
            [Constants.FeedbackTopics.ACCOUNT_MANAGER_QUERY]: this.accountManagerEmail,
            [Constants.FeedbackTopics.TECHNICAL_SUPPORT]: Constants.SupportEmails.TECHNICAL_SUPPORT_EMAIL,
            [Constants.FeedbackTopics.DATA_QUERY]: Constants.SupportEmails.DATA_QUERY_EMAIL,
            [Constants.FeedbackTopics.OTHER_QUERY]: Constants.SupportEmails.OTHER_QUERY_EMAIL,
        };

        return emails[this.contactUsFormGroup.value.topic] || Constants.SupportEmails.TECHNICAL_SUPPORT_EMAIL;
    }

    public onSubmit(formValue: { topic: string; message: string }): void {
        this.isSuccessful = false;
        this.showResponse = false;
        if (this.contactUsFormGroup.invalid || formValue.message.trim().length === 0) {
            this.showResponse = true;
            this.response = 'Message is required';
            return;
        }

        const feedback = this.emailBuilder
            .setFromEmail(this.userData.email)
            .setFromName(this.userData.name)
            .setSubject(formValue.topic)
            .setBody(formValue.message)
            .setToEmail(this.emailBasedOnTopic);

        return this.sendEmail(feedback.build());
    }

    private sendEmail(email: Email): void {
        this.helpResourcesStore.dispatch(sendContactUsFeedback({ email }));
    }
}
